module.exports = __webpack_public_path__ + "assets/img/LTC031.d98e6329.png";